module.exports = __webpack_public_path__ + "img/thumb-logitech-room-configurator@2x.6759f123.png";